import axiosInstance from "../../axios/axiosInstance";
import { GET_AI_LISTING_ANALYTICS, GET_LOCATION_ANALYTICS, GET_PROMOCODE_ANALYTICS, GET_SEARCH_ANALYTICS, GET_USER_ACTIVITY_ANALYTICS } from "../../constants";

// api/context/analytics.js
export const getSearchAnalytics = (params) => onResponse => {
    try {
        axiosInstance.get(GET_SEARCH_ANALYTICS, {
            params: params // Send as query parameters
        })
        .then((response) => {
            onResponse(response.data);
        })
        .catch((err) => {
            console.log(err)
            onResponse(err);
        });
    } catch (error) {
        console.error(error);
    }
};

export const getUserActivityAnalytics = (params) => onResponse => {
    try {
        axiosInstance.get(GET_USER_ACTIVITY_ANALYTICS, {
            params: params // Send as query parameters
        })
        .then((response) => {
            onResponse(response.data);
        })
        .catch((err) => {
            console.log(err)
            onResponse(err);
        });
    } catch (error) {
        console.error(error);
    }
};

export const getLocationAnalytics = (params) => onResponse => {
    try {
        axiosInstance.get(GET_LOCATION_ANALYTICS, {
            params: params
        })
        .then((response) => {
            onResponse(response.data);
        })
        .catch((err) => {
            console.log(err)
            onResponse(err);
        });
    } catch (error) {
        console.error(error);
    }
};

export const getPromocodeAnalytics = (params) => onResponse => {
    try {
        axiosInstance.get(GET_PROMOCODE_ANALYTICS, {
            params: params
        })
        .then((response) => {
            onResponse(response.data);
        })
        .catch((err) => {
            console.log(err)
            onResponse(err);
        });
    } catch (error) {
        console.error(error);
    }
};

export const getAiListingAnalytics = (params) => onResponse => {
    try {
        axiosInstance.get(GET_AI_LISTING_ANALYTICS, {
            params: params
        })
        .then((response) => {
            onResponse(response.data);
        })
        .catch((err) => {
            console.log(err)
            onResponse(err);
        });
    } catch (error) {
        console.error(error);
    }
};
